/* global window */
/* global document */
import { Fragment, useContext } from 'react'
import { Header, Sider } from 'components'
import { Layout, Drawer } from 'antd'
import { config, getLocale } from 'utils'
import store from 'store2'
import styles from './PrimaryLayout.module.scss';
import { changeTheme, RouterContext, setSidebar } from 'components-contexts/RouterContext'
import { PublicMenuList } from './PublicMenuList'
import { MenuList as DoctorMenuList } from 'client/components/doctors/sidebar/SideMenuList';

const { Content } = Layout


const PublicLayout = (props) => {
  const { account, children, isMobile, isAuthenticated } = props;
  const { state, dispatch } = useContext(RouterContext)

  const {collapsed, theme} = state;
  
  
  const onCollapseChange = collapsed => {
    dispatch(setSidebar(collapsed));
  }

 
    const user = store.get('user') || {}
    const routeList = isAuthenticated ?  DoctorMenuList  : PublicMenuList;

    // Localized route name.

    const lang = getLocale()
    /*const newRouteList =
      lang !== 'en'
        ? routeList.map(item => {
            const { label, ...other } = item
            return {
              ...other,
              label: (item[lang] || {}).label || label,
            }
          })
        : routeList*/

    const menus = routeList;// newRouteList.filter(_ => (_.type === 0 || _.type === account?.type) || (_.type === 0 && !isAuthenticated && !_.auth))

    const headerProps = {
      theme,
      menus,
      collapsed,
      notifications: null ,
      onCollapseChange,
      avatar: user.avatar,
      username: user.username,
      fixed: config.fixedHeader,
      publicLayout:true,
      isMobile,
      onAllNotificationsRead() {
        // dispatch({ type: 'app/allNotificationsRead' })
      },
    }

    const siderProps = {
      theme,
      menus,
      isMobile,
      collapsed,
      isAuthenticated,
      account,
      publicLayout:true,
      onCollapseChange,
      onThemeChange(theme) {
        dispatch(changeTheme(theme))
      },
    }

    return (
      <Fragment>
        <Layout hasSider={true}>
        {isMobile &&
          <Drawer
            width={256}
            maskClosable
            closable={false}
            onClose={() => {onCollapseChange(!collapsed)}}
            visible={!collapsed}
            placement="left"
            style={{
              padding: 0,
              height: '100vh',
            }}
          >
            <Sider {...siderProps} collapsed={false} />
          </Drawer>
        }
          <div
            className={styles.container}
            style={{ paddingTop: config.fixedHeader && props.location.pathname !== "/app-reference" ? 52 : 0 }} 
            id="primaryLayout"
          >
            {/* <Header {...headerProps} /> */} {props.location.pathname !== "/app-reference" && <Header {...headerProps} />}
            {/* <Content> */}
              {children}
            {/* </Content> */}
          </div>
        </Layout>
      </Fragment>
    )
  
}


// export default withRouter(PublicLayout)
export default PublicLayout;

